import { render, staticRenderFns } from "./gameMenuPanel.vue?vue&type=template&id=3a75d9b0&lang=pug"
import script from "./gameMenuPanel.vue?vue&type=script&lang=js"
export * from "./gameMenuPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports